var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakeoutDining(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.966 61.6668L24.266 38.3334H55.7994L54.0993 61.6668H25.966ZM32.766 18.3334H47.1994L56.5327 27.4334L56.2327 31.6667H23.7327L23.4327 27.4334L32.766 18.3334ZM73.3327 26.5334L68.6327 21.8334L63.3327 27.1001L63.4327 25.2334L49.9327 11.6667H30.066L16.566 25.2334L16.666 26.9001L11.366 21.7001L6.66602 26.4667L17.4327 36.8334L19.766 68.3334H60.2327L62.566 36.8668L73.3327 26.5334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeoutDining);
export default __webpack_public_path__ + "static/media/takeout_dining.35430d6afee17c0b04d439643df55554.svg";
export { ForwardRef as ReactComponent };